import React, { Component, useState, useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import Slider from "react-slick";
import { TodoListComponent } from '../apps/TodoList'
import { VectorMap } from "react-jvectormap"

import { MdOutlineWork, MdOutlineSwapVert } from "react-icons/md";
import { FaFileWaveform } from "react-icons/fa6";
import { HiChartSquareBar } from "react-icons/hi";
import { VscVmRunning } from "react-icons/vsc";
import SortableList from "../components/sortableList";
import { AiOutlineFilePdf } from "react-icons/ai";
import { arrayMoveImmutable } from 'array-move';

import axios from 'axios';
import Bars from '../components/Dashboard1/Charts/BarChart';
import Lines from '../components/Dashboard1/Charts/LineChart';
import RectangleChart from '../components/Dashboard1/Charts/rectangleChart';
import ProgressBar from '../components/Dashboard1/Charts/progressBar';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './dasboard.css'
import DoughnutChart from '../components/Dashboard1/Charts/DoughnutChart'

const mapData = {
  "BZ": 75.00,
  "US": 56.25,
  "AU": 15.45,
  "GB": 25.00,
  "RO": 10.25,
  "GE": 33.25
}

function Dashboard() {
  const [items, setItems] = useState([{ graph: 'MTD', value: 1, visible: true }, { graph: 'WTD', value: 2, visible: true }, { graph: 'QTD', value: 3, visible: true }, { graph: 'Running', value: 4, visible: true }, { graph: 'Top 3', value: 5, visible: true }])
  let [isseuCount, setIssueCount] = useState()
  function downloadPdf() {
    const input = pdfRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfwidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfwidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfwidth - imgWidth * ratio) / 2
      const imgY = 30;
      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      pdf.save((new Date()) + ".pdf");
    })
  }

  const pdfRef = useRef();

  var transactionHistoryData = {
    labels: ["Paypal", "Stripe", "Cash"],
    datasets: [{
      data: [55, 25, 20],
      backgroundColor: [
        "#111111", "#00d25b", "#ffab00"
      ]
    }
    ]
  };

  const [progressBarData, setProgressData] = useState([])
  const [summaryData, setSummaryData] = useState([])
  const [topList, setTopList] = useState([])


  function getTopList() {
    axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q3-top-3', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
      if (data.data.success) {


        setTopList(data.data['DQ-Pipeline-Details-Q3 Top-3 Data'])
      }
    })
  }

  useEffect(() => {
    signIN()
  }, [])

  function signIN() {
    axios.post(process.env.REACT_APP_API_POINT +"auth/login", { username: "saral", password: "saral" }, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).then((data) => {
      if (data.data.success == true) {
        sessionStorage.setItem('token', data.data.access_token)

        axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q3-running-status', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
          if (data.data.success) {


            setProgressData(data.data['DQ-Pipeline-Details-Q3 Running-Status Data'])
            axios.get(process.env.REACT_APP_API_POINT +'DQ-pipeline/pipeline-details-Q1', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
              if (data.data.success) {
                let summary = {}
                data.data['DQ-Pipeline-Details-Q1 Data'].forEach(element => {
                  if (element.Flag == "DataLoaders") {
                    summary.pdiJobs = element['Total Count']
                  }
                  else if (element.Flag == "MetaMorphs") { summary.tranformation = element['Total Count'] }
                  else if (element.Flag == "RuningStatus") { summary.runningStatus = element['Total Count'] }
                  else if (element.Flag == "SchdulerKTR") { summary.ktr = element['Total Count'] }
                  else if (element.Flag == "SchdulerJobs") { summary.schJob = element['Total Count'] }
                });
                setSummaryData(summary)

              }
            })
          }
        })
        getTopList()
      }
    })
  }

  var transactionHistoryOptions = {
    responsive: true,
    maintainAspectRatio: true,
    segmentShowStroke: false,
    cutoutPercentage: 70,
    elements: {
      arc: {
        borderWidth: 0
      }
    },
    legend: {
      display: false
    },
    tooltips: {
      enabled: true
    }
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems(prevItem => (arrayMoveImmutable(prevItem, oldIndex, newIndex)));

  };

  function getElementFromIndex(index) {

    return (<>



      {index.value == '1' && index.visible && <>
        <div className="col-md-4 col-xl-4 " >
          <div className="card charts ">
            <div className="card-body bg-white text-black " >
              <div className="d-flex flex-row justify-content-between">
                <span className="card-title text-dark graph-label" style={{ marginBottom: "0px" }}>MTD Issue Occured</span>

              </div>
              <DoughnutChart setIssueCount={setIssueCount}></DoughnutChart>
            </div></div></div>
      </>}
      {index.value == '2' && index.visible && <>
        <div className="col-md-4 col-xl-4 ">
          <div className="card charts ">
            <div className="card-body bg-white text-black ">
              <div className="">
                <span className="card-title text-dark graph-label">WTD Issue Occured</span>
              </div>
              <Bars></Bars>
            </div></div></div>
      </>}
      {index.value == '3' && index.visible && <>
        <div className="col-md-4 col-xl-4 ">
          <div className="card charts ">
            <div className="card-body bg-white text-black ">
              <div className="">
                <span className="card-title text-dark graph-label">QTD Issue Occurred</span>
              </div>
              <Lines></Lines></div></div></div>
      </>}


      {index.value == '4' && index.visible && <>
        <div className="col-md-4 col-xl-4 ">
          <div className="card charts ">
            <div className="card-body bg-white text-black ">
              <div className="mb-5">
                <span className="card-title text-dark graph-label ">Running Status</span>
              </div>
              {progressBarData && progressBarData.map((p, ind) => { return <div style={{ marginBottom: "2.2rem" }}> <ProgressBar bgcolor={progressColor[ind]} lightColor={lightColor[ind]} completed={p['Error Count Precent']} heading={p['Status']} /></div> })}
            </div></div></div></>}
      {index.value == '5' && index.visible && <>
        <div className="col-md-4 col-xl-4" >
          <div className="card charts ">
            <div className="card-body bg-white text-black ">
              <div className="" style={{ marginBottom: "4.4rem" }}>
                <span className="card-title text-dark graph-label">Top 3 (taking more than 3mins)</span>
              </div>
              {topList && topList.map((val, ind) => {
                return (<div className="" style={{ marginBottom: "3.6rem" }}>
                  <RectangleChart bgcolor={rectangleColor[ind]} completed={val['Taken Time']} business={val['Task Name']} />
                </div>)
              })}
            </div></div></div>
      </>}

    </>)
  }

  function checkGraph(index) {

    let temp = [...items]
    temp[index].visible = !temp[index].visible
    setItems(temp)

  }
  var sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }
  const [showSwap, setShowSwap] = useState(false)

  function toggleProBanner() {
    document.querySelector('.proBanner').classList.toggle("hide");
  }
  let progressColor = ["#f53838", "#ffaa01", "#15b8a7"]
  let lightColor = ["#fcc3c3", "#F7E6C6", "#C4F5F1"]
  let rectangleColor = ["#3b82f6", "#f69d0b", "#15b8a7"]

  return (
    <div style={{paddingBottom:"20rem"}} ref={pdfRef}>

      <div >
        <div className='bg-white topics'>
          <div className="row">
            <div className="col-12 grid-margin stretch-card">
              <div className="card bg-white border0 text-dark">
                <div className="card-body py-0 px-0 px-sm-3">
                  <div className="row align-items-center">
                    <div className="col-md-8 col-sm-12 col-xl-8 p-0">
                      <h2 className="mb-1 mb-sm-0 text-dark">Dashboard</h2>
                      <h4 className="mb-0 font-weight-normal my-2 d-none text-dark d-sm-block">Welcome To DatablendIQ</h4>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xl-12 p-0 d-flex justify-content-end">
                      <div style={{ position: "relative" }}>
                        <button className="btn   text-dark swapButton" onClick={() => setShowSwap(!showSwap)} ><MdOutlineSwapVert></MdOutlineSwapVert>Swap</button>
                        {showSwap && <div className="DragDropMenu pl-2" onMouseLeave={() => { setShowSwap(false) }} style={{ position: "absolute", left: "0px", zIndex: "99", border: "1px solid #767676", backgroundColor: "#fff" }}>
                          <SortableList items={items} className={'item'} onSortEnd={onSortEnd} checkGraph={checkGraph} />
                        </div>}
                      </div>
                      <button className="btn   text-dark swapButton" onClick={() => downloadPdf()}> <AiOutlineFilePdf className='chart-icon mb-1'></AiOutlineFilePdf>Generate Report</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row" >
            <div className="col-xl-3 col-sm-6 grid-margin stretch-card" >
              <div className="card bg-white h-75 text-dark border0 ">
                <div className="card-body interstedBox" style={{ backgroundColor: "#ff91915e" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">PDI Jobs</h5>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon  ">
                        <MdOutlineWork className="job" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData.pdiJobs}</h3>
                  <span className='text-primary'>+8% from yesterday</span>

                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div className="card bg-white h-75 text-dark border0">
                <div className="card-body interstedBox" style={{ backgroundColor: "#ffe08b65" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">Transformation</h5>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon ">
                        <HiChartSquareBar className="chart" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData.tranformation}</h3>
                  <span className='text-primary'>+5% from yesterday</span>

                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 grid-margin stretch-card">
              <div className="card  bg-white h-75 text-dark border0">
                <div className="card-body interstedBox " style={{ backgroundColor: "#85ff9f5e" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">Schedule Jobs/KTR</h5>

                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon ">
                        <FaFileWaveform className="form" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal">{summaryData.schJob + "/" + summaryData.ktr}</h3>
                  <span className='text-primary'>.</span>

                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 grid-margin ">
              <div className="card bg-white h-75 text-dark border0">
                <div className="card-body interstedBox" style={{ backgroundColor: "#dc91ff5e" }}>
                  <div className="row">
                    <div className="col-9">
                      <div className="d-flex align-items-center align-self-start">
                        <h5 className="mb-0">Running Status</h5>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="icon  ">
                        <VscVmRunning className="status" />
                      </div>
                    </div>
                  </div>
                  <h3 className="text-muted font-weight-normal text-dark">{summaryData.runningStatus}</h3>
                  <div className='row'>
                    <div className='col-md-6' style={{ height: "10px", width: "10%", borderRadius: "10px", marginLeft: "15px", backgroundColor: "#ab28df" }}>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="row">

          {items.map((item, index) => {
            return (<>


              {getElementFromIndex(item)}

            </>
            )
          })}



        </div>
      </div>
    </div>
  );

}

export default Dashboard;